export const measurementUnits = {
  imperial: 'INCH',
  metric: 'CM'
}

export const weightUnits = {
  imperial: 'LB',
  metric: 'KG'
}

export const scanFormInfo = {
  carriers: ['USPS'],
  serviceTypes: ['USPS_CJ', 'USPS', 'USPS_CJ_VIP'],
  warehouses: process.env.NODE_ENV === 'production' ? ['kTkQBnEhi0hJwTwrIJ1K'] : ['3MB7q4SayBWsyZTNG0H3', 'SOtxMwbJUOqq5R12hF5g']
}

export const PRICING_OPTIONS = {
  ONE_RATE: 'ONE_RATE',
  STANDARD_RATE: 'STANDARD_RATE'
}



// WEBPACK FOOTER //
// ./src/utils/const.js